// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2K_XF","imageUploader":"EGiftCard_imageUploader__3kUL3"};